import React from "react";

import { IProps } from "./types";

export const ExternalLink: React.FC<IProps> = props => (
  <a
    target="_blank"
    rel="nofollow noopener"
    {...props}
  >
    {props.children}
  </a>
);
